/**
 * Returns a new array with items in random order (Fisher–Yates). Does not mutate the input.
 *
 * @param items Source list (e.g. suggestion chips from the API).
 * @returns Shuffled copy for display rotation; server does not shuffle.
 */
export function shuffleChatSuggestions<T>(items: readonly T[]): T[] {
  const copy = [...items];
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const tmp = copy[i]!;
    copy[i] = copy[j]!;
    copy[j] = tmp;
  }
  return copy;
}
